<div class="consolidation-filter">
  <input type="text" class="form-control" placeholder="{{ placeholder }}" [(ngModel)]="inputValue" (ngModelChange)="onChange()"/>
</div>
